export default {"src":"/_next/static/media/SimpleDeployment.d7bb9b4f.svg","height":448,"width":870};